var exports = {
  "M": "x4ddf2309--33383d--slide",
};

module.exports = exports;
